import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AppCapability } from './authorization';
import { AuthorizationService } from './authorization.service';

@Injectable({
  providedIn: 'root',
})
export class CapabilityGuard implements CanActivate {
  constructor(private authorization: AuthorizationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const required = route.data['requiredCapability'] as
      | AppCapability
      | ReadonlyArray<AppCapability>
      | undefined;

    if (!required) {
      return true;
    }

    const allowed = Array.isArray(required)
      ? this.authorization.canAny(required)
      : this.authorization.can(required as AppCapability);

    return allowed ? true : this.router.createUrlTree(['/scores']);
  }
}
